import { FC, HTMLAttributes } from 'react';

import useTooltipVoorraad from '../../hooks/useTooltipVoorraad';
import { AtomicRBCMaterieelMap } from '../../state/types/VoorraadbeheerStore';
import { getClaimsTotaal } from '../../utils/voorraadbeheer';
import SidepanelToggle from '../Sidepanel/Toggle/SidepanelToggle';

import VoorraadDots from './VoorraadDots';

import styles from './VoorraadListItem.module.css';

type VoorraadListItemProps = HTMLAttributes<HTMLDivElement> & {
  voorraad: AtomicRBCMaterieelMap;
};
const VoorraadListItem: FC<VoorraadListItemProps> = ({ voorraad, ...divProps }) => {
  const { showTooltip, updateTooltip, hideTooltip } = useTooltipVoorraad();

  return (
    <SidepanelToggle voorraad={voorraad}>
      <div
        onMouseEnter={showTooltip(voorraad.rbc, voorraad)}
        onMouseMove={updateTooltip(voorraad.rbc, voorraad)}
        onMouseLeave={hideTooltip}
        className={[styles.row, divProps?.className ?? ''].join(' ')}
        {...divProps}
      >
        <div>{voorraad.rbc}</div>
        <VoorraadDots
          aantal={voorraad.overOfTekort}
          claimsCount={getClaimsTotaal(voorraad.claims)}
          beschikbareReizigersdienst={voorraad.aanwezig - voorraad.inzetten - voorraad.nietInzetbaar}
          nvt={voorraad.nvt}
        />
      </div>
    </SidepanelToggle>
  );
};
export default VoorraadListItem;
